<dynamic-view-v2
    *ngIf="!isLoading"
    entityType="challenge-keywords"
    [viewName]="title"
    [record]="keywordRecord"
    [fields]="fields"
>
</dynamic-view-v2>